import OtherTemplate from '../docs/_template';

export default OtherTemplate;


// WEBPACK FOOTER //
// ./examples/_template.jsx